import * as v from 'valibot';
import Ajax from '../util/ajax';
import { panelAdded } from '../features/panels/panelsSlice';
import { panelSchema } from '../types/Panel';
export function createPanel(panel, callback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/panel/create';
        ajax.post(url, panel, data => {
            const res = v.safeParse(panelSchema, data);
            if (res.success) {
                dispatch(panelAdded(res.output));
                callback();
            }
            else {
                console.error(v.summarize(res.issues));
            }
        });
    };
}
